export const SYSTEM_GENERATED_CATEGORY_LIST = ['Manning Fee Auto'];

export const getPoCategoryValueFromListType = (poListType) => {
  if (poListType === 'crew') return 0;
  if (poListType === 'vessel') return 1;
  if (poListType === 'agency') return 2;
  return null;
};

export const filterExpenseCategoriesByPoListType = (categories, poListType) => {
  const poCategoryValue = getPoCategoryValueFromListType(poListType);
  if (!categories?.length || poCategoryValue == null) return [];
  return categories.filter((item) => {
    if (!item?.poCategory) return false;
    const hasMatchingPoCategory = Array.isArray(item.poCategory)
      ? item.poCategory.includes(poCategoryValue)
      : item.poCategory === poCategoryValue;
    if (!hasMatchingPoCategory) return false;
    if (SYSTEM_GENERATED_CATEGORY_LIST.includes(item.categoryName)) return false;
    return true;
  });
};

export const filterExpenseCategoriesForPoFilter = (categories) => (
  (categories || []).filter(
    (item) => item?.categoryName
      && !SYSTEM_GENERATED_CATEGORY_LIST.includes(item.categoryName)
  )
);

export const getPoExpenseCategoryId = (po) => (
  po?.expenseCategoryId
  ?? po?.expenseCategoryID
  ?? po?.expenseCategory?.id
  ?? ''
);

export const matchesPoExpenseCategoryFilter = (po, expenseCategoryId, expenseCategoryName) => {
  if (!expenseCategoryId && !expenseCategoryName) return true;

  const poId = getPoExpenseCategoryId(po);
  if (expenseCategoryId && poId
    && String(poId).toLowerCase() === String(expenseCategoryId).toLowerCase()) {
    return true;
  }

  const poName = (po?.expenseCategoryName || po?.expenseCategory?.categoryName || '')
    .trim()
    .toLowerCase();
  const filterName = (expenseCategoryName || '').trim().toLowerCase();
  if (filterName && poName) {
    return poName === filterName
      || poName.includes(filterName)
      || filterName.includes(poName);
  }

  return false;
};
